import React from 'react';
import c from 'classnames';

import type { RelatedContentProps } from './types';

import './style.scss';

// Subcomponents.
import MoreButton from './MoreButton';
import RelatedArticles from './RelatedArticles';
import RelatedEvents from './RelatedEvents';
import Title from './Title';

interface Subcomponents {
  MoreButton: typeof MoreButton;
  RelatedArticles: typeof RelatedArticles;
  RelatedEvents: typeof RelatedEvents;
  Title: typeof Title;
}

const RelatedContent: React.FC<Omit<RelatedContentProps, 'type' | 'args' | 'filters'>> & Subcomponents = ({
  className,
  children,
  ...restProps
}) => {
  const classes = c('RelatedContent', 'content-section', className);

  return (
    <div className={classes} {...restProps}>
      {children}
    </div>
  );
};

RelatedContent.MoreButton = MoreButton;
RelatedContent.RelatedArticles = RelatedArticles;
RelatedContent.RelatedEvents = RelatedEvents;
RelatedContent.Title = Title;

export default RelatedContent;
